module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "m2000",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('menus-horizon', {
    attrs: {
      "size": "sm",
      "current": _vm.content,
      "surface": [{
        icon: 'like',
        currentIcon: 'likefill',
        alias: 'like',
        title: '收 藏'
      }, {
        icon: 'time',
        currentIcon: 'timefill',
        alias: 'time',
        title: '时光机'
      }, {
        icon: 'shop',
        currentIcon: 'shopfill',
        alias: 'shop',
        title: '小 摊'
      }]
    },
    on: {
      "on-click": _vm.handleclick
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "m2000",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('menus-horizon', {
    attrs: {
      "size": "sm"
    }
  }, [_c('menus-horizon-item', {
    attrs: {
      "alias": "like",
      "icon": "like",
      "current-icon": "likefill",
      "title": "收 藏",
      "tip": 0,
      "current": _vm.content == 'like'
    },
    on: {
      "on-click": _vm.handleclick
    }
  }), _vm._v(" "), _c('menus-horizon-item', {
    attrs: {
      "alias": "time",
      "icon": "time",
      "current-icon": "timefill",
      "title": "时光机",
      "tip": 0,
      "current": _vm.content == 'time'
    },
    on: {
      "on-click": _vm.handleclick
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "34px",
      "padding-top": "30px",
      "color": "#999"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.content) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8e1f3f8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus-horizon/demo.vue
// module id = 274
// module chunks = 23